import React from "react";

/**
 * Gap/overlap-safe PDF page wrapper (already includes all class names)
 */
export default function Page({
  children,
  pageNumber,
  quote,
  hideFooter = false,
  className = "" // e.g., "page--whisper", "page--quoteXL"
}) {
  const hasQuote = !!(quote && String(quote).trim());
  return (
    <section className={`page${hasQuote ? "" : " no-quote"} ${className}`}>
      <div className="page__pad">
        <div className="page__content">{children}</div>

        {hasQuote && (
          <div className="page__quote">
            <span>“{quote}”</span>
          </div>
        )}

        {!hideFooter && (
          <div className="page__footer">
            <div className="stars">✦ ✦ ✦</div>
            <div className="pnum">{pageNumber}</div>
          </div>
        )}
      </div>
    </section>
  );
}
